import React, { useMemo } from 'react'
import ExpandableSection from './ExpandableSection'
import { isEmpty } from 'lodash-es'
import { Tools } from '../../toolbar/Tools'
import Item from './Item'

const SortedList = ({ componentsList }) => {
  const filteredComponents = useMemo(() => {
    const checkboxComponents = componentsList.filter((component) => component.type === 'checkbox')
    const dataComponents = componentsList.filter((component) => component.type === 'data')
    const signatureComponents = componentsList.filter((component) => component.type === 'signature')
    return { dataComponents, checkboxComponents, signatureComponents }
  }, [componentsList])

  return (
    <>
      {filteredComponents.dataComponents.map((component) => (
        <Item key={component.key} component={component} />
      ))}
      {filteredComponents.checkboxComponents.map((component) => (
        <Item key={component.key} component={component} iconClassName="fa-light fa-square-check" />
      ))}
      {filteredComponents.signatureComponents.map((component) => (
        <ExpandableSection key={component.id} component={component} />
      ))}
    </>
  )
}

const DefaultNoFields = () => {
  return (
    <div className="instructional">
      <p>All fields will display here.</p>
      <p>
        Add a field with
        <span>
          data <i className={Tools.data.icon}></i>
        </span>
      </p>
      <p>
        Add a signature field with
        <span>
          sign <i className={Tools.signature.icon}></i>
        </span>
      </p>
    </div>
  )
}

const LabelsList = ({ componentsList }) => {
  return (
    <div className="section-container scrollable">
      {isEmpty(componentsList) ? <DefaultNoFields /> : <SortedList componentsList={componentsList} />}
    </div>
  )
}

export default LabelsList
